import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { AtHomeServicesView } from '@nedoShared/modules/explore/AtHoveServicesView/AtHomeServicesView';
import ProgramsView from '@core/src/nedoShared/modules/explore/ProgramsView/ProgramsView';
import { usePageErrorBoundary } from '../../library/providers/PageProvider';
import { SelectProgram, } from '@core/src/nedoShared/modules/orders/SelectProgram/SelectProgram';
import styles from './ExplorePage.module.scss';
import { $router } from 'ziphy-web-shared/basic/utils/router';
const ExplorePage = () => {
    const { t } = useTranslation();
    const errorBoundary = usePageErrorBoundary();
    const [activeProgram, setActiveProgram] = useState($router.searchParams.get('tab') || 'programs');
    const updateActiveProgram = (program) => {
        $router.searchParams.set('tab', program);
    };
    useEffect(() => {
        const program = $router.searchParams.get('tab');
        if (!program) {
            setActiveProgram('programs');
        }
        else {
            setActiveProgram(program);
        }
    }, [$router.search]);
    return (_jsx("div", Object.assign({ className: "content" }, { children: _jsxs("div", Object.assign({ className: classNames('container', styles.contentInner) }, { children: [_jsx(Title, Object.assign({ size: 'h1', className: 'mb-15' }, { children: t('label.explore') })), _jsx(SelectProgram, { activeProgram: activeProgram, setActiveProgram: updateActiveProgram }), activeProgram === 'programs' && _jsx(ProgramsView, {}), activeProgram === 'at_home_services' && _jsx(AtHomeServicesView, {})] })) })));
};
export default observer(ExplorePage);
